import {
  DigitalTextFieldCellPropertiesType,
  DigitalTextFieldPropertiesType
} from "@website/ui/digital-text-field/digital-text-field.types";
import { ChangeEvent, useCallback, useRef, useState } from "react";

const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
const englishDigits = "0123456789";

export const toEnglishDigits = (string_: string) =>
  string_.replaceAll(
    /[۰-۹]/g,
    (ch) => englishDigits[persianDigits.indexOf(ch)]
  );

export const useDigitalTextField = (
  properties: DigitalTextFieldPropertiesType
) => {
  const inputReference = useRef<HTMLInputElement>(null);
  const [hasFocus, setHasFocus] = useState<boolean>(false);
  const { onChange, error, value, variant, num } = properties;

  const onChangeInput = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value_ = toEnglishDigits(event.target.value);
      if (value_.length <= num && !Number.isNaN(Number(value_))) {
        onChange(value_);
      }
    },
    [num, onChange]
  );

  const onClickCell = useCallback(() => {
    if (inputReference?.current?.focus) {
      inputReference.current.focus();
    }
  }, []);

  const onFocusInput = useCallback(() => {
    setHasFocus(true);
  }, []);

  const onBlurInput = useCallback(() => {
    setHasFocus(false);
  }, []);

  const cellsProperties: Array<DigitalTextFieldCellPropertiesType> = [];
  for (let index = 0; index < num; index++) {
    cellsProperties.push({
      error: error || false,
      text: value[index] || "",
      variant,
      onClick: onClickCell,
      focus:
        hasFocus &&
        (value.length === index || (value.length === num && index === num - 1))
    });
  }

  return {
    cellsProps: cellsProperties,
    inputProps: {
      autoFocus: true,
      ref: inputReference,
      onFocus: onFocusInput,
      onBlur: onBlurInput,
      inputMode: "numeric" as const,
      type: "text",
      onChange: onChangeInput,
      value,
      autoComplete: "one-time-code"
    }
  };
};
